<div class="row my-2 px-5 hl-product-grid">
  <div class="col-12 col-sm-6 col-md-3 px-4 py-3 product-card" *ngFor="let product of mappedData">

    <!-- Group 1: image + name + description (variable height — row track grows to tallest card) -->
    <div class="product-card-top">
      <div class="product-image d-flex justify-content-center" *ngIf="showImage">
        <ng-template
          ngTemplateOutlet
          *ngIf="!product.extra.oldProduct; then productImg; else oldProductImg"
        ></ng-template>
        <ng-template #productImg>
          <a [routerLink]="['/product/', product.id]">
            <img
              class="img-fluid"
              *ngIf="!!product.extra.images && !!product.extra.images[0]"
              [src]="
                product.extra.images[0].s3Uri | gungImageUrl: 'type:list' : 'etag:' + product.extra.images[0].s3ETag : 'size:1000x1000'
              "
              alt=""
            />
          </a>
        </ng-template>
        <ng-template #oldProductImg>
          <div class="old-product-image">
            <img src="assets/old-product.png" class="img-fluid" />
            <div class="text text-center" translate>OLD_PRODUCT_IMAGE</div>
          </div>
        </ng-template>
      </div>

      <div class="product-info" [ngStyle]="isSales ? { 'min-height': '58px' } : {}">
        <div class="product-name mb-1 h5 font-weight-bold mt-2">
          <a class="product-link" routerLink="/product/{{ product.id }}">
            @if (product.extra.i18n?.[currentLang]?.artbeskrspec) {
              {{ product.extra.i18n[currentLang].artbeskrspec }}
            } @else if (product.extra.ar.artbeskrspec) {
              {{ product.extra.ar.artbeskrspec }}
            } @else {
              {{ product.extra.ar.artbeskr }}
            }
          </a>
        </div>
        @if (isSales) {
          <div class="product-text">({{ product.extra.ar.artbeskr }})</div>
        }
      </div>
    </div>

    <!-- Group 2: price + ID + size + basecost (aligned across all cards in a row) -->
    <div class="product-card-price">
      <div class="h5 font-weight-bold price d-block mt-2" *ngIf="!hidePrices">
        @if (displayStaffedPrices && product.price) {
          <hl-display-price
            [price]="product.price"
            priceLevelsDisplayType="FULL"
            displayOnlyPrice="true"
            type="STAFFED"
            [currentQty]="product.extra.minimumOrderQuantity"
            [assortmentType]="getAssortmentType(product.extra)"
          ></hl-display-price>
        } @else {
          <span *ngIf="product.price">
            {{
              product.price.customerGrossPrice.value
                | gungCurrency: product.price.customerGrossPrice.currencyCode : 'symbol-narrow' : '1.2-2' : 'sv_SE'
            }}
          </span>
          @if (displayDiscountFromPriceList && product.price?.backendPrice?.levels?.[0]?.extra?.prl?.proc1 > 0) {
            <span class="text-disc">(-{{ product.price.backendPrice.levels[0].extra.prl.proc1 }}%)</span>
          }
          <span>{{ getAssortmentType(product.extra) }}</span>
        }
      </div>

      <div class="product-id">
        <span translate>ID</span>: {{ product.id }}
        @if (!!currentCustomer && currentCustomer.extra.kuarMapped?.[product.id]?.artnrkund) {
          &nbsp;({{ currentCustomer.extra.kuarMapped[product.id]?.artnrkund }})
        }
      </div>

      <div class="product-size">
        @if (productSize && productSize[product.id]) {
          <span translate>SIZE</span>: {{ productSize[product.id] }}
        }
      </div>

      <div class="product-basecost">
        <span
          *ngIf="
            (isSales || isCustomerService) &&
            product.price &&
            getAssortmentType(product.extra) === '(W)' &&
            product.extra.ar.q_basecost_start &&
            product.extra.ar.q_basecost_unit
          "
          class="d-block"
        >
          <span translate>BASECOST_S_U</span>:
          {{ (product.extra.ar.q_basecost_start | number: '1.2-2') + (baseCostCurrency ? ' ' + baseCostCurrency : '') }}
          /
          {{ (product.extra.ar.q_basecost_unit | number: '1.2-2') + (baseCostCurrency ? ' ' + baseCostCurrency : '') }}
        </span>
      </div>
    </div>

    <!-- Group 3: availability + icons + button (aligned across all cards in a row) -->
    <div class="product-card-actions">
      <div class="product-availability" *ngIf="!hideAvailabilities">
        <app-hl-display-availability [availability]="product.availability"></app-hl-display-availability>
      </div>

      <div class="d-flex mb-1 icon-row">
        <app-hl-display-favourite-product-icon class="product-info-icon" [id]="product.id"></app-hl-display-favourite-product-icon>
        @if (product.extra?.hlVideos?.[0]?.videoUrl) {
          <a class="product-info-icon" [href]="product.extra.hlVideos[0].videoUrl" target="_blank" [title]="'VIDEO' | translate">
            <i class="fa-regular fa-circle-play"></i>
          </a>
        } @else {
          <span class="product-info-icon disabled">
            <i class="fa-regular fa-circle-play"></i>
          </span>
        }
        @if (product.extra?.documents?.[0]) {
          <a class="product-info-icon" [href]="product.extra.documents[0] | gungDownloadUrl" target="_blank" [title]="'DOCUMENT' | translate">
            <i class="fa-regular fa-file-lines"></i>
          </a>
        } @else {
          <span class="product-info-icon disabled">
            <i class="fa-regular fa-file-lines"></i>
          </span>
        }
      </div>
      <app-hl-display-buy-btn
        class="w-100"
        [product]="product"
        [price]="product.price"
        *ngIf="!product.extra.oldProduct"
        [id]="product.id"
      ></app-hl-display-buy-btn>
    </div>

  </div>
</div>
